<template>
  <div class="drawer-detail">
    <div class="field-type" style="border:none">
      <span class="label">附件:</span>
      <table class="address">
        <thead>
          <td style="width:100px">类型</td>
          <td style="width:150px">附件名称</td>
        </thead>
        <tbody>
          <tr v-for="item in project.附件" :key="item._id">
            <td style="width:100px">{{item['type']}}</td>
            <td style="width:150px" @click="preview(item)">
              <span class="link-item">{{item['originalname']}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="field-type upload-btn-box" style="border:none">
      <el-select class="mr10" v-model="type" filterable size="mini" placeholder="请选择">
        <el-option v-for="item in attachmentTypes" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button type="primary" size="mini" style="margin-bottom:8px" @click="showUpload">附件上传</el-button>
    </div>

    <UploadDialog
      ref="UploadDialog"
      type="附件"
      :label="type"
      :on-success="uploadsuccess"
      :on-error="uploaderror"
    />
  </div>
</template>
<script>
import { projectFileTypes } from '../../../../../project/src/constant/type'

export default {
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['附件'],
      attachmentTypes: projectFileTypes,
      type: '',
    }
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        if (newValue && !oldValue) this.type = ''
        else if (newValue && oldValue && newValue._id !== oldValue._id) this.type = ''
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 文件预览
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile(file)
      ref.show()
    },
    showUpload() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async uploadsuccess(response, file, filelist) {
      const res = response[0]
      const type = this.type
      try {
        await app.service('project').insertProjectFile([
          Object.assign(res, {
            type: type || '附件',
            projectId: this.project._id,
          }),
        ])
        this.$message.success(`上传成功`)
        this.getProjectFiles()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async uploaderror(responce) {
      console.log(responce)
    },
    async getProjectFiles() {
      const { data } = await app.service('file').projectFiles({ query: { projectId: this.project._id } })
      this.$set(this.project, '附件', data)
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
.upload-btn-box {
  margin-top: 30px;
  display: flex;
}
.upload-btn-box .radish-btn {
  flex: none;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
